import { useState } from 'react';
import { useTeamStore } from '@/store/useTeamStore';
import { TeamBubbleView } from './TeamBubbleView';
import { TeamPlaylist } from './TeamPlaylist';
import { MemberForm } from './MemberForm';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Plus, Sparkles, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { routes } from '@/lib/routes';
import { useChatStore } from '@/store/useChatStore';

export function TeamDashboard() {
  const { members } = useTeamStore();
  const { createSession, setActiveSession } = useChatStore();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  function startTeamConsult() {
    if (members.length < 2) {
      toast.info('Du brauchst mindestens 2 Teammitglieder für eine Team-Konsultation.');
      return;
    }
    const session = createSession('consultation', members.map((m) => m.id));
    setActiveSession(session.id);
    navigate(routes.innerTeam.teamChat(session.id));
  }

  return (
    <div className="flex-1 overflow-y-auto">
      {members.length === 0 ? (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center gap-6 px-8">
          <div className="text-5xl">🌱</div>
          <div className="space-y-2">
            <h2 className="text-xl font-semibold">Dein Team wartet</h2>
            <p className="text-sm text-muted-foreground max-w-xs">
              Beginne eine Entdeckungsreise im Chat und deine inneren Anteile werden hier als
              Teammitglieder erscheinen.
            </p>
          </div>
          <Button className="gap-2" onClick={() => navigate(routes.innerTeam.discovery())}>
            <Sparkles size={16} />
            Entdeckungsreise starten
          </Button>
        </div>
      ) : (
        <>
          <TeamBubbleView />
          <div className="px-4 pb-4">
            <Button
              className="w-full gap-2"
              onClick={startTeamConsult}
              disabled={members.length < 2}
            >
              <Users size={16} />
              Team befragen
            </Button>
          </div>
          <TeamPlaylist />
        </>
      )}

      {/* FAB */}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger
          render={
            <Button
              size="icon"
              className="fixed right-4 w-14 h-14 rounded-full shadow-lg"
            style={{ bottom: 'calc(4rem + env(safe-area-inset-bottom) + 1rem)' }}
              aria-label="Manuell hinzufügen"
            />
          }
        >
          <Plus size={24} />
        </DialogTrigger>
        <DialogContent className="max-h-[90dvh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Teammitglied hinzufügen</DialogTitle>
          </DialogHeader>
          <MemberForm
            onSave={() => {
              setOpen(false);
              toast.success('Teammitglied hinzugefügt!');
            }}
            onCancel={() => setOpen(false)}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
